import React from "react";
import { StyleSheet } from "react-native";

import { kColors } from "src/kColors";

import { PdLink } from "src/components/Icons";
import { ComposerToolbarIconButton } from "./components";
import { useComposer } from "./utils";

const AddLinkButton: React.FC = () => {
  const { onAddLink } = useComposer();
  return <ComposerToolbarIconButton icon={<PdLink style={styles.composerIconSend} />} onPress={onAddLink} />;
};

export default AddLinkButton;

const styles = StyleSheet.create({
  composerIconSend: {
    color: kColors.gray500,
    width: 15,
  },
});
